import { langSwitchStyle } from '_core/components/LangSwitch/langSwitchStyle';

export const contactsPopupStyle = (theme) => ({
  ...langSwitchStyle(theme),

  buttonIcon: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '1em',
    height: '1em',
    fontSize: '1em',
    '& svg': {
      width: '100%',
      height: '100%',
    },
  },
  list: {
    padding: 0,
  },
  paper: {
    padding: 30,
  },
  ContactsList: {
    display: 'flex',
    alignItems: 'flex-start',
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },
  ContactsPhone: {
    textDecoration: 'none',
    display: 'inline-flex',
    color: 'inherit',
  },
  ContactsIcon: {
    alignItems: 'center',
    minWidth: theme.spacing(5),
    color: theme.palette.text.secondary,
  },
  ContactsContent: {
    display: 'flex',
    flexDirection: 'column',
  },
  ContactsLabel: {
    display: 'block',
    textAlign: 'left',
    marginTop: theme.spacing(0.5),
  },
  ContactsResult: {
    color: theme.variables.colors.primary,
    lineHeight: 1.2,
  }
});
